import { Controller } from "@hotwired/stimulus"

// Manages the phone change OTP flow on the profile edit page
// Shows/hides the OTP request form inline
export default class extends Controller {
  static targets = ["display", "form"]

  toggle(event) {
    event.preventDefault()
    this.displayTarget.classList.toggle("hidden")
    this.formTarget.classList.toggle("hidden")
  }

  cancel(event) {
    event.preventDefault()
    this.displayTarget.classList.remove("hidden")
    this.formTarget.classList.add("hidden")
  }
}
